import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { FilesService } from '@core/services';
import { Content, ImageSizeEnum } from 'lingo2-models';

export enum ESizeCard {
  micro,
  mid,
  normal,
}

@Component({
  selector: 'app-gallery-content-card',
  standalone: true,
  templateUrl: './gallery-content-card.component.html',
  styleUrls: ['./gallery-content-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LocaleSharedModule, CommonModule],
})
export class GalleryContentCardComponent implements OnInit {
  cdr = inject(ChangeDetectorRef);

  @Input() set content(content: Content) {
    this._content = content;
    this.coverImgUrl = FilesService.getFileUrlBySize(this._content.cover_id, this.sizeCover);
    this.title = content.title;
  }
  @Input() public set sizeCard(sizeCard: ESizeCard) {
    this._sizeCard = sizeCard;
    switch (sizeCard) {
      case ESizeCard.normal:
        this.sizeCover = ImageSizeEnum.md;
        break;
      default:
        this.sizeCover = ImageSizeEnum.sm;
    }
    this.coverImgUrl = FilesService.getFileUrlBySize(this._content.cover_id, this.sizeCover);
  }
  public get sizeCard() {
    return this._sizeCard;
  }
  @Output() openCard = new EventEmitter<Content>();

  private _content: Content;
  private _sizeCard: ESizeCard;
  private sizeCover: ImageSizeEnum;

  public coverImgUrl: string;
  public title: string;
  public eSizeCard = ESizeCard;

  ngOnInit() {}

  public onOpenCard() {
    this.openCard.emit(this._content);
  }
}
